export const CLIENT_STAGING_URL = "";
export const API_STAGING_URL = ''
export const API_DEV_URL = 'http://localhost:3131/'

export const IS_STAGING = window.location.host === CLIENT_STAGING_URL
export const DISABLE_FETCH = IS_STAGING

export const API_BASE_URL = IS_STAGING ? API_STAGING_URL : API_DEV_URL